module.exports = __webpack_public_path__ + "img/bg.a8f59513.png";